import "./App.css";
import Reviews from "./Components/reviews";
import data from "./data";

const App = () => {
  return (
    <section className="container">
      <div id="header">
        <h1 id="our-review">Our Reviews</h1>
        <p id="line"></p>
      </div>
      <Reviews data={data} />
    </section>
  );
};

export default App;
